export { Home } from "./Home";
export { ViewConverted } from "./view_converted/ViewConverted";
export { PdfToImg } from "./PdfToImg";
export { PdfSplit } from "./PdfSplit";
export { WordToEpub } from "./WordToEpub";
export { AboutUS } from "./AboutUs";
export {ContactUs} from './ContactUs';
export {FAQPage} from './FaqPage';
